import React from "react";
import { Route, Navigate, Routes } from "react-router-dom";

import { HomePage } from "../pages/home/HomePage";
import DrilldownPage from "../pages/drilldown/DrilldownPage";
import { WebContentPreviewPage } from "../pages/blockPageContent/WebContentPreviewPage";
import { SafetyPreviewPage } from "../pages/blockPageContent/SafetyPreviewPage";

import { HelpPageRouter } from "./HelpPageRouter";
import { SettingsRouter } from "./SettingsRouter";
import { useRestoreSession } from "../hooks";

export const AuthRouter = () => {
  useRestoreSession();

  return (
    <Routes>
      <Route path="home" element={<HomePage />} />

      <Route path="drilldown/:page" element={<DrilldownPage />} />

      <Route path="settings/*" element={<SettingsRouter />} />

      <Route path="preview/web-filtering" element={<WebContentPreviewPage />} />

      <Route path="preview/safety" element={<SafetyPreviewPage />} />

      <Route path="help/*" element={<HelpPageRouter />} />

      <Route path="*" element={<Navigate to="home" />} />
    </Routes>
  );
};
